// src/components/GallerySlider.jsx
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Importa todas las imágenes de src/img/portfolio (no recursivo)
function importAll(r) {
  return r.keys().sort().map(r);
}
const images = importAll(
  require.context("../img/portfolio", false, /\.(png|jpe?g|webp|gif|svg)$/)
);

export default function GallerySlider() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: true,
    // Ordena los breakpoints de mayor a menor
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480, // Valor de breakpoint más bajo para móviles
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    // El resto de tus configuraciones
    appendDots: (dots) => (
      <div
        style={{
          position: "relative",
          bottom: "-40px",
        }}
      >
        <ul style={{ margin: "0px" }}> {dots} </ul>
      </div>
    ),
  };

  return (
    <div className="gallery-wrapper">
      <div className="slider-container">
        <Slider {...settings}>
          {images.map((src, i) => (
            <div key={i} style={{ padding: "0 10px" }}> {/* Añade espacio entre imágenes */}
              {/* 1. Contenedor para centrar y limitar la altura */}
              <div
                style={{
                  height: "500px", // Define una altura máxima para las imágenes
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#f9f9f9", // Color de fondo opcional
                  borderRadius: "10px",
                }}
              >
                {/* 2. Estilos de la imagen corregidos */}
                <img
                  src={src}
                  alt={`Galería ${i + 1}`}
                  style={{
                    maxWidth: "100%",    // La imagen no superará el ancho del contenedor
                    maxHeight: "100%",   // La imagen no superará la altura del contenedor
                    width: "auto",       // El ancho se ajusta automáticamente
                    height: "auto",      // La altura se ajusta automáticamente
                    objectFit: "contain",// Asegura que toda la imagen sea visible
                  }}
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}